/**
 * Lightweight hook to detect if running in React Native WebView
 * Separated from useWebViewAuth to avoid routing/rendering dependencies
 */
export const useIsRNWebView = () => {
  // Simple webview detection - no auth logic, no side effects
  const isRNWebView = !!(window as any).IS_RN_WEBVIEW;

  return { isRNWebView };
};
